import { TextCollectionResponse } from '@scale/shared/types/response/textcollection';
import apiFetch from '@scale/frontend-lib/api-fetch';
import {
  TextCollectionSaveCheckpointRequest,
  TextCollectionSaveCheckpointResponse,
  TextCollectionGetCheckpointResponse,
} from '@scale/shared/types/textCollection';

export const saveServerCheckpoint = async (id: string, response: TextCollectionResponse) => {
  const body: TextCollectionSaveCheckpointRequest = {
    response,
  };
  await apiFetch<TextCollectionSaveCheckpointResponse>(
    null,
    `internal/textcollection/${id}/checkpoint`,
    {
      method: 'POST',
      body,
    },
  );
};

export const getServerCheckpoint = async (id: string): Promise<TextCollectionResponse | null> => {
  const checkpointResponse = await apiFetch<TextCollectionGetCheckpointResponse>(
    null,
    `internal/textcollection/${id}/checkpoint`,
    {
      method: 'GET',
    },
  );
  if (checkpointResponse.isDisabled || !checkpointResponse.success) {
    return null;
  }
  return checkpointResponse.response ?? null;
};
